<template>
  <gsp-alert-error>
    <p class="vm-mb-2">
      <strong>
        {{
          t("labels.serviceErrorHeading", curServiceData.errorHeadingLabelData)
        }}</strong
      >
    </p>
    <p
      v-for="(error, index) in curServiceData.errors"
      v-html-t="['htmlMarkup.serviceErrorPara', error]"
      :key="index"
      class="vm-mb-2 vm-break-all"
    />
    <div v-if="isLastService">
      <gsp-divider class="vm-my-4" />
      <p v-html-t="'htmlMarkup.needAssistanceHelplineStatement'" />
    </div>
  </gsp-alert-error>
</template>

<script setup>
import { useI18n } from "vue-i18n";

const props = defineProps({
  curServiceData: {
    type: Object,
    required: true,
  },
  isLastService: {
    type: Boolean,
    required: true,
  },
});

const { t } = useI18n();
</script>
